import {useCallback, useEffect} from 'react';

import {useDebounce} from '#hook/useDebounce';

/**
 * This hook returns an object containing the X and Y coordinates for the
 * cursor, if available. These values are debounced to avoid unnecessarily
 * frequent updates.
 */
export function useCursorPos({delay = 100}) {
  const [pos, setPos] = useDebounce<{x: number; y: number}>({x: 0, y: 0}, delay);

  const updateMousePosition = useCallback(
    (ev: MouseEvent) => {
      setPos({x: ev.clientX, y: ev.clientY});
    },
    [setPos],
  );

  useEffect(() => {
    window.addEventListener('mousemove', updateMousePosition);

    return () => {
      window.removeEventListener('mousemove', updateMousePosition);
    };
    // Empty deps to ensure eventlistener is only inititialized on mount.
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return pos;
}
